/**
 * Patient Info Cell Component
 *
 * Two-line cell displaying:
 * - Line 1: Patient name (clickable link style, ws-elm-500)
 * - Line 2: Room and age subtext (muted, ws-big-stone-400)
 */

import { calculateAge } from "../../types/residents";
import { STYLES } from "../../config/styles";

interface PatientInfoCellProps {
  residentName: string;
  room: string | null;
  dateOfBirth: string | null;
  lastMdsDate?: string | null;
  mdsType?: string | null; // MDS ISC code (e.g., "01" = Admission)
  onClick?: () => void;
  className?: string;
}

export function PatientInfoCell({
  residentName,
  room,
  dateOfBirth,
  onClick,
  className,
}: PatientInfoCellProps) {
  const age = calculateAge(dateOfBirth);

  // Build subtext: "Room {room} · {age}y" or just available parts
  const subtextParts: string[] = [];
  if (room) {
    subtextParts.push(`Room ${room}`);
  }
  if (age !== null) {
    subtextParts.push(`${age}y`);
  }
  const subtext = subtextParts.join(" · ");

  return (
    <td className={`${STYLES.table.cellPadding}${className ? ` ${className}` : ""}`}>
      <div className="flex flex-col gap-0.5">
        <button
          type="button"
          onClick={onClick}
          className="text-left text-sm font-medium hover:underline focus:outline-none focus:underline"
          style={{ color: "#228189" }} // ws-elm-500
        >
          {residentName}
        </button>
        {subtext && (
          <span
            className="text-xs"
            style={{ color: "#3D5463" }} // ws-big-stone-400
          >
            {subtext}
          </span>
        )}
      </div>
    </td>
  );
}
